import './TileOverlay.scss';

import { ReactComponent as PadlockIcon } from 'images/icons/Padlock.svg';
import { observer } from 'mobx-react-lite';

type TileOverlayProps = {
  color: string;
  overlayText: React.ReactNode | string;
  descriptionClassNames?: string;
};

export const TileOverlay = observer(({ color, overlayText, descriptionClassNames }: TileOverlayProps) => {
  return (
    <div className='tile-overlay-wrapper'>
      <div className={`tile-overlay-description ${descriptionClassNames ?? ''}`}>
        <div className='padlock-icon' style={{ backgroundColor: `${color}` }}>
          <PadlockIcon />
        </div>
        <span>{overlayText}</span>
      </div>
    </div>
  );
});

export default TileOverlay;
